export const ClickOutsideDirective = {
    mounted(el, binding) {
        if (typeof window === 'undefined') {
            return; // Early return if not in browser, making it SSR-safe
        }


        // Define the clickOutsideEvent function
        const clickOutsideEvent = function(event) {
            // Check if the clicked area is outside the element and its children
            if (!(el === event.target || el.contains(event.target))) {
                // Check if the provided expression is a function
                if (typeof binding.value === 'function') {
                    // Call the provided function
                    binding.value(event);
                } else {
                    // Optionally, log an error or warning in development mode
                    console.error(`Expecting a function, got ${typeof binding.value}`);
                }
            }
        };
        // Attach the clickOutsideEvent function to the element for later access
        el.__vueClickOutside__ = clickOutsideEvent;

        // Attach the listener to the document
        document.addEventListener('click', clickOutsideEvent);

        console.log('added')

    },
    unmounted(el) {
        if (typeof window === 'undefined') {
            return; // Early return if not in browser, making it SSR-safe
        }
        // Use the stored reference to remove the event listener
        document.removeEventListener('click', el.__vueClickOutside__);
        // Clean up by removing the property
        el.__vueClickOutside__ = null;
        console.log('removed')
    },
};
